import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import QuestionAnswerComponent, {Question} from "../../components/help/QuestionAnswerComponent.tsx";
import CallMeRTOComponent from "../../components/callMe/CallMeRTOComponent.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import {Link} from "react-router-dom";
import TDCMBBHeroComponent from "../../components/hero/TDCMBBHeroComponent.tsx";
import TDC5GQualitySectionComponent from "../../components/tdc5g/TDC5GQualitySectionComponent.tsx";
import TDC5GSetupStepsSectionComponent from "../../components/tdc5g/TDC5GSetupStepsSectionComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";
import TDC5GTrophySectionComponent from "../../components/tdc5g/TDC5GTrophySectionComponent.tsx";
import TDC5GCoverageMap from "../../components/tdc5g/TDC5GCoverageMap.tsx";
import Icon from "../../components/selfcare/Icon.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import Routing from "../../Routing.ts";
import IconArrow from "../../components/icons/IconArrow.tsx";

const questions: Question[] = [
    {
        question: 'Hvad betyder fri data?',
        answer: <p>
            Fri data betyder, at du har ubegrænset data på din internetforbindelse.
            Du skal ikke betale ekstra, uanset hvor meget data du bruger. Det betyder, at du kan streame, downloade, browse og bruge internettet frit uden at bekymre dig om at løbe tør for data eller blive opkrævet ekstra gebyrer, når du når en bestemt grænse.
        </p>
    },
    {
        question: 'Kan jeg få internet til sommerhus med mobilt bredbånd?',
        answer: <p>
            Ja, det kan du sagtens.
            Da mobilt bredbånd er mobilt og fleksibelt, kan du sagtens købe dit 5G-internet og tage det med dig i dit <Link to="/hjaelp/bestilling/internet-i-sommerhus">sommerhus,</Link> så længe der er dækning og en stikkontakt. <button
                className={'link'}
                onClick={() => DispatchHighLightAddressSearchEvent(true)}
            >Slå gerne adressen på dit sommerhus op</button> for at se, hvilken hastighed du kan få.
        </p>
    },
    {
        question: 'Hvad er den bedste placering til min 5G-router?',
        answer: <p>
            Det er bedst at placere sin 5G-router ved et vindue, således at den står så tæt som muligt på den nærmeste mast.
            Du kan læse mere om <Link to="/hjaelp/internet-og-wifi/placering-af-router">den bedste placering af din 5G-router her</Link>.
        </p>
    },
    {
        question: 'Hvad er forskellen på bredbånd og mobilt bredbånd?',
        answer: <p>
            Forskellen mellem bredbånd og mobilt bredbånd ligger primært i, hvordan internetforbindelsen bliver leveret.
            Bredbånd bliver leveret via kabler og mobilt bredbånd via en trådløs forbindelse.
            Læs mere om <Link to="/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge">forskellene mellem de forskellige internetforbindelser her</Link>.
        </p>
    },
    {
        question: 'Kan jeg tage mit mobile bredbånd med til udlandet og gøre brug af roaming?',
        answer: <p>
            Nej, du kan ikke tage dit mobile bredbånd fra Hiper med til udlandet.
            Med mobilt bredbånd fra Hiper, kan man kun bruge 5G-internet i Danmark.
        </p>
    },
    {
        question: 'Tilbyder Hiper mobilabonnementer?',
        answer: <p>
            Nej, vi tilbyder ikke mobilabonnementer &ndash; men udelukkende en trådløs internetforbindelse via mobilt bredbånd.
        </p>
    },
]

export default function MobileBroadbandPage() {
    ScrollToTop()
    useDatalayer()
    setTitleAndMetaDescription(
        'Mobilt bredbånd med fri data | Lynhurtigt trådløst internet',
        'Køb mobilt internet fra Hiper fra 199,-/md. og få en lynhurtig 5G-lånerouter med i dit abonnement. Du er hurtig online med en nem installation.'
    )

    return (
        <div className={"page-products-mobile"}>
            <TDCMBBHeroComponent/>
            <TDC5GQualitySectionComponent/>
            <TDC5GSetupStepsSectionComponent/>
            <TDC5GTrophySectionComponent/>

            <section className="mbb-includes">
                <div className="content content--medium">
                    <h2 className="heading heading--montserrat heading--big">Det får du med i dit mobile bredbåndsabonnement:</h2>
                    <div className="item">
                        <div className="text">
                            <h3 className="heading heading--montserrat heading--medium heading--left">Fri og ubegrænset data </h3>
                            <p>
                                Med mobilt internet fra Hiper får du fri data.
                                Ja, du læste helt rigtigt &ndash; fri data!
                                Så du kan bruge dit 5G-internet helt ubegrænset og surfe og streame lige så meget, som du har lyst til.
                            </p>
                        </div>
                        <img src={imageMap.products.surfing_5g_router} alt="Surf løs med mobilt internet fra Hiper!"/>
                    </div>
                    <div className="item alt">
                        <div className="text">
                            <h3 className="heading heading--montserrat heading--medium heading--left">5G mobilt bredbånd router og SIM-kort</h3>
                            <p>
                                Udover den tilkøbte hastighed, får du i dit mobile internet-abonnement hos Hiper, en lynhurtig 5G-lånerouter samt et SIM-kort, som du skal bruge til opsætning af dit mobile bredbånd.
                                Du kan læse mere om <a
                                href="/5g-internet-vejledning"
                                target="_blank"
                            >opsætningen af din 5G-router her</a>.
                            </p>
                        </div>
                        <img src={imageMap.products.zyxel_nr5307_back_with_sim} alt="Hipers 5G-lånerouter til dit mobile bredbånd."/>
                    </div>
                    <div className="item">
                        <div className="text">
                            <h3 className="heading heading--montserrat heading--medium heading--left">Adgang til egen selvbetjening</h3>
                            <p>
                                Når du bestiller dit mobile bredbåndsabonnement hos Hiper, får du adgang til din egen selvbetjening, Mit Hiper, hvor du kan finde dine regninger, skifte betalingskort m.m.
                            </p>
                        </div>
                        <img
                            src={imageMap.products.selfcare}
                            alt="Med mobilt bredbånd fra Hiper får du adgang til din egen selvbetjening via Mit Hiper."
                        />
                    </div>
                </div>
            </section>          

            <CallMeRTOComponent className={"rto--section page-products"}/>

            <section className="mbb-advantages">
                <div className="content content--narrow">
                    <h2 className="heading heading--montserrat heading--big">3 fordele ved at vælge mobilt bredbånd</h2>
                    <div className="box-container">
                        <div className="box">
                            <span className="number">1</span>
                            <div className="text">
                                <h3 className="heading heading--montserrat heading--medium heading--left">Nem og hurtig installation</h3>
                                <p>
                                    Med mobilt internet er det nemt og enkelt at komme i gang.
                                    Du indsætter blot det tilsendte SIM-kort i din 5G-router, tilslutter strøm, og så er du klar til at forbinde til dit wifi.
                                    Det betyder, at du slipper for teknikerbesøg og kabellægning, som ofte følger med traditionelle internetforbindelser.
                                </p>
                            </div>
                        </div>
                        <div className="box">
                            <span className="number">2</span>
                            <div className="text">
                                <h3 className="heading heading--montserrat heading--medium heading--left">Fleksibelt trådløst bredbånd</h3>
                                <p>
                                    Mobilt internet er trådløst bredbånd, hvilket f.eks. giver dig frihed til at tage routeren med i sommerhuset.
                                </p>
                            </div>
                        </div>
                        <div className="box">
                            <span className="number">3</span>
                            <div className="text">
                                <h3 className="heading heading--montserrat heading--medium heading--left">Fri og ubegrænset data</h3>
                                <p>
                                    Med vores mobile bredbånd får du fri data hver måned.
                                    Det betyder at du kan streame, surfe og bruge internettet lige så meget, du vil, uden at bekymre dig om at løbe tør for data.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mbb-router">
                <div className="content content--medium">
                    <h2 className="heading heading--montserrat heading--big">En af de bedste 5G-routere til dit mobile bredbånd</h2>
                    <div className="text-image-container">
                        <div className="text">
                            <p>
                                Når du vælger mobilt bredbånd hos os, får du en lånerouter med i dit mobile internet abonnement.
                                Routeren giver lynhurtige datahastigheder og understøtter både LAN og wifi.
                            </p>
                            <p>
                                Vores 5G-router er til SIM-kort, men den har også to Ethernet LAN-porte, hvis du vil <Link to="/hjaelp/internet-og-wifi/hastighedstest">foretage en 5G-hastighedstest</Link>.
                                Du kan også tilslutte dine enheder direkte via kabel for optimal forbindelse.
                                Routeren er meget brugervenlig og enkel at sætte op &ndash; læs mere om <a
                                href="/5g-internet-vejledning"
                                target="_blank"
                            >opsætningen af 5G-routeren i vores guide</a>.
                            </p>
                            <p>
                                Designet er stilrent og hvidt, hvilket gør, at den passer ind i de fleste hjem.
                                Den er nem at tage med på farten, men er kun egnet til indendørs brug, hvilket gør den ideel til trådløst internet til hjemmet.
                            </p>
                            <p>
                                Hvilken router du præcist får med i dit abonnement, afhænger af hvad vi har tilgængeligt når du bestiller.
                                Den ene router er Zyxel NR5307 og den anden er Huawei H158-381.
                                Begge routere er super gode og leverer en hurtig 5G-forbindelse til hjemmet.
                            </p>
                        </div>
                        <img
                            className="hide-on-small-devices"
                            src={imageMap.products.zyxel_nr5307}
                            alt="5G-router som du får med, når du køber mobilt internet hos Hiper."
                        />
                        <img
                            className="hide-on-large-devices"
                            src={imageMap.products.zyxel_nr5307_white_square}
                            alt="Køb mobilt bredbånd hos Hiper, og du får denne 5G-lånerouter med i dit abonnement."
                        />
                    </div>
                </div>
            </section>

            <section className="mbb-what">
                <div className="content content--narrow">
                    <div className="item">
                        <div className="text">
                            <h2 className="heading heading--montserrat heading--big heading--left">Et godt tip til at optimere din 5G-hastighed</h2>
                            <p>
                                Placér din 5G-router i en vindueskarm så centralt i din bolig som muligt, så din router får det bedste signal fra den mest nærliggende 5G-mast i dit område.
                                Disse 5G-master er placeret i hele landet.
                                Det er fra disse 5G-master, at din 5G-forbindelse bliver opsnappet fra, som til slut giver internet til din router, så du kan få wifi til hjemmet.
                            </p>
                        </div>
                    </div>
                    <div className="item">
                        <div className="text">
                            <h2 className="heading heading--montserrat heading--big heading--left">Hvad er mobilt bredbånd?</h2>
                            <p>
                                Mobilt bredbånd er en trådløs internetforbindelse, der bruger mobilnetværk som 4G eller 5G til at give internetadgang.
                                I stedet for at have en kablet forbindelse, som f.eks. fibernet eller internet via kabel-tv, fungerer mobilt bredbånd via en 5G-router og et SIM-kort.
                                Dette gør det muligt at få internet, hvor som helst der er mobildækning.
                            </p>
                        </div>
                    </div>
                    <div className="item">
                        <div className="text">
                            <h2 className="heading heading--montserrat heading--big heading--left">Trådløst internet til hjemmet</h2>
                            <p>
                                Med mobilt bredbånd indsætter du dit SIM-kort i din 5G-router og placerer din router nær et vindue eller et åbent område, for at sikre det bedste signal til den nærmeste mast.
                                Når routeren modtager 5G-signalet, distribuerer den trådløst internet via wifi, som dine enheder kan koble på.
                                På den måde får du nemt og hurtigt mobilt internet til hjemmet.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mbb-faq">
                <div className="content content--narrow">
                    <h2 className="heading heading--montserrat heading--big">Godt at vide om mobilt bredbånd</h2>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </section>

            <section className="mbb-coverage">
                <div className="content">
                    <h2 className="heading heading--montserrat heading--big">Se om vi dækker med 5G mobilt bredbånd i dit område</h2>
                    <p>
                        Vi tilbyder 5G mobilt bredbånd i næsten hele Danmark via TDC NET.
                        5G-internet er den nyeste generation af mobilnetværk, der leverer hurtigt, sikkert og trådløst internet til alle dine enheder &ndash; mobil, computer, tablet og TV.
                    </p>
                    <p>
                        Mobilt bredbånd er trådløst internet, du kan tage med dig i <Link to="/hjaelp/bestilling/internet-i-sommerhus?cmf=fiber">sommerhuset,</Link> campingturen eller andre steder.
                        Du kan også indsætte dit SIM-kort direkte i din computer eller tablet for at få internetadgang.
                    </p>
                </div>

                <div className="content content--medium">
                    <TDC5GCoverageMap/>
                    <p className="coverage-map-disclaimer">
                        Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                    </p>
                </div>

                <div className="content">
                    <h3 className="heading heading--montserrat heading--medium">Se hvilke 5G-områder med mobilt internet, som vi dækker</h3>
                    <p>
                        På dækningskortet har vi markeret alle de områder, som vi dækker med vores mobile internet.
                        Lige nu kan du få mobilt bredbånd for kun 199,-/md. i de første 3 måneder.
                        Herefter er normalprisen 279,-/md.
                        Den præcise 5G-hastighed, du kan få, afhænger af din adresse.
                    </p>
                    <p className="align-center">
                        <button
                            className={'button button--montserrat big rounded with-icon'}
                            onClick={() => DispatchHighLightAddressSearchEvent(true)}
                        >
                            Slå din adresse op her
                            <Icon component={IconArrow}/>
                        </button>
                    </p>
                    <p>
                        Hvis du vil se hvilke andre internetforbindelser, som vi også udbyder kan du tjekke <Link to={Routing.Broadband.Index}>bredbåndssiden</Link>.
                    </p>
                </div>
            </section>
        </div>
    )
}
